module.exports = __webpack_public_path__ + "img/symbol_5.9b2505bc.png";